// CustomerServiceScriptLoader.jsx
import React from 'react';
import PropTypes from 'prop-types';

const listenEvents = ['mousemove', 'scroll', 'click'];

export class CustomerServiceScriptLoader extends React.PureComponent {
  idleCallback = null;
  timeout = null;

  initCustomerService = async () => {
    this.clearSideEffects();

    const { intercomId, zendeskKey, displayIntercom } = this.props;
    if (!intercomId && !zendeskKey) {
      return;
    }

    try {
      const { init, ProviderName } = await import(
        '../resource/customerService.js'
      );
      const providerName = zendeskKey
        ? ProviderName.ZENDESK
        : intercomId
          ? ProviderName.INTERCOM
          : '';
      await init({ providerName, args: { intercomId, zendeskKey } });

      return displayIntercom();
      // eslint-disable-next-line no-empty
    } catch (_) {}
  };

  clearSideEffects = () => {
    listenEvents.forEach(event => {
      document.removeEventListener(event, this.initCustomerService);
    });
    cancelIdleCallback(this.idleCallback);
    clearTimeout(this.timeout);
  };

  initTimeout = () => {
    const { timeoutMsec } = this.props;
    this.timeout = setTimeout(this.initCustomerService, timeoutMsec);
  };

  componentDidMount() {
    this.idleCallback = requestIdleCallback(this.initTimeout);
    listenEvents.forEach(event => {
      document.addEventListener(event, this.initCustomerService);
    });
  }

  componentWillUnmount() {
    this.clearSideEffects();
  }

  render() {
    return null;
  }
}

CustomerServiceScriptLoader.propTypes = {
  intercomId: PropTypes.string,
  zendeskKey: PropTypes.string,
  timeoutMsec: PropTypes.number,
  displayIntercom: PropTypes.func,
};

CustomerServiceScriptLoader.defaultProps = {
  intercomId: '',
  timeoutMsec: 1000,
  displayIntercom: () => null,
};

export default CustomerServiceScriptLoader;
